import { CountriesAlpha2 } from '@sequencehq/api/commonEnums'

// List of countries we care about having states for
export const SUPPORTED_COUNTRIES_WITH_STATES: CountriesAlpha2[] = ['US']
